import styled from '@emotion/styled';
import { Box, Flex, Text, HR, Popover } from '@updater/ui-uds';
import { CaretRight } from '@phosphor-icons/react';
import React, { PropsWithChildren, ReactNode } from 'react';

const InfoTextWrapper = styled(Text)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const InfoBoxWrapper = styled(Box)`
  overflow: hidden;
  * {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export interface InfoRowProps {
  heading?: string;
  description?: string | ReactNode;
  tooltipMessage?: string;
  onClick?: () => void;
}

type WrapperProps = {
  clickable?: boolean;
};
const Wrapper = styled(Box)<WrapperProps>`
  background: none;
  color: inherit;
  text-align: left;
  ${(props) =>
    props.clickable
      ? `
    div {
      cursor: pointer;
    }
    &:hover {
      background: ${props.theme.colors.itemHoverBackground};
    }
  `
      : ''}
`;

export const InfoRow: React.FC<PropsWithChildren<InfoRowProps>> = ({
  heading,
  description,
  tooltipMessage,
  children,
  onClick,
}) => {
  const content = description || children;
  const wrapperType = typeof content;

  return (
    <Wrapper
      data-testid="info-row"
      onClick={onClick}
      width="100%"
      height="100%"
      padding="none"
      margin="none"
      border="none"
      paddingTop={['s', 's', 'm']}
      clickable={typeof onClick === 'function'}
    >
      {heading && (
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          paddingX="xs"
        >
          <Flex alignItems="center">
            <Text as="h2" variant={['lBold', 'lBold', 'xlBold']} mr="xs">
              {heading}
            </Text>
            {tooltipMessage && (
              <Popover details={tooltipMessage} maxwidth={20} />
            )}
          </Flex>
          {typeof onClick === 'function' && <CaretRight size={24} />}
        </Flex>
      )}
      {content && (
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          alignItems="center"
          paddingLeft="xs"
          paddingRight="m"
        >
          {wrapperType === 'string' ? (
            <InfoTextWrapper
              as="h3"
              variant="m"
              marginTop={['none', 'none', heading ? 'xs' : 'none']}
            >
              {content}
            </InfoTextWrapper>
          ) : (
            <InfoBoxWrapper
              marginTop={['none', 'none', heading ? 'xs' : 'none']}
            >
              {content}
            </InfoBoxWrapper>
          )}

          {!heading && typeof onClick === 'function' ? (
            <CaretRight size={24} />
          ) : (
            <Box />
          )}
        </Flex>
      )}
      <Box marginBottom={['s', 's', 'm']} />
      <HR />
    </Wrapper>
  );
};
